import AddressConfigModel from '../models/addressConfigModel';
import DashboardModel from '../models/dashboardModel';
import AddressModel from '../models/addressModel';

/**
 * Builds the months array for templates to iterate over
 * @return {array} An array of objects with information about all 12 months
 */
export function months(state) {
    const months = [{
        name: state.core.localizations.containers.chromeLocalization['account_month_values_january'],
        days: 31,
        number: '01'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_february'],
        days: 29,
        number: '02'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_march'],
        days: 31,
        number: '03'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_april'],
        days: 30,
        number: '04'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_may'],
        days: 31,
        number: '05'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_june'],
        days: 30,
        number: '06'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_july'],
        days: 31,
        number: '07'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_august'],
        days: 31,
        number: '08'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_september'],
        days: 30,
        number: '09'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_october'],
        days: 31,
        number: '10'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_november'],
        days: 30,
        number: '11'
    }, {
        name: state.core.localizations.containers.chromeLocalization['account_month_values_december'],
        days: 31,
        number: '12'
    }];

    return months;
}

/**
 * Builds days array for templates to iterate over
 * @param  {number} dayCount Number of days
 * @return {array}           An array of day numbers
 */
export function days(dayCount) {
    let dayArray = [];
    for (let i = 1; i <= dayCount; i++) {
        dayArray.push(i);
    }
    return dayArray;
}

/**
 * return years incrementally
 * @param  {startYear} startYear year to start the range
 * @param  {endYear} endYear year to end the range
 * @return {Array} An array of years
 */
export function years(startYear, endYear) {
    let yearArray = [];

    for (var i = startYear; i <= endYear; i++) {
        let item = {
            name: i,
            value: i
        };

        yearArray.push(item);
    }
    return yearArray;
}

/**
 * Builds the gender array for templates to iterate over
 * @param  {object} state The current state of the redux store
 * @return {array}        An array of objects containing key/value pairs of gender info
 */
export function genders(state) {
    const gender = [{
        name: state.core.localizations.containers.chromeLocalization['gender_values-female'],
        value: "FEMALE"
    }, {
        name: state.core.localizations.containers.chromeLocalization['gender_values-male'],
        value: "MALE"
    }, {
        name: state.core.localizations.containers.chromeLocalization['gender_values-unknown'],
        value: 'UNKNOWN'
    }];
    return gender;
}

export function selectedCountry() {
    return AddressConfigModel.selectedCountry;
}

/**
 * Gets country based on core data
 * @param  {object} state Initial state of the redux store
 * @return {object}       Response object to be passed to model set method
 */
export function getInitialSelectedCountry(state) {
    const initialCountry = {
        data: state.core.userLocation.country_code,
        nonApiResponse: true
    };

    return initialCountry;
}

/**
 * Gets the initial groupType based on the country/siteId returned via akamai
 * @param  {object} state The current state of the redux store
 * @return {object}       A "response" object to be passed to the model's `set` method
 */
export function getInitialGroupType(state) {
    const siteIndex = getSiteBySiteId(state);
    const countryIndex = getCountryIndexBySelectedCountry(state);
    const initialGroupType = _.get(state, `core.siteConfig.allCountries.${countryIndex}.groupType`);

    const initialGroupTypeResponse = {
        data: initialGroupType,
        nonApiResponse: true
    };

    return initialGroupTypeResponse;
}

export function states() {
    return [{
        'name': 'alabama',
        'alpha-2': 'AL'
    }, {
        'name': 'alaska',
        'alpha-2': 'AK'
    }, {
        'name': 'arizona',
        'alpha-2': 'AZ'
    }, {
        'name': 'arkansas',
        'alpha-2': 'AR'
    }, {
        'name': 'california',
        'alpha-2': 'CA'
    }, {
        'name': 'colorado',
        'alpha-2': 'CO'
    }, {
        'name': 'connecticut',
        'alpha-2': 'CT'
    }, {
        'name': 'delaware',
        'alpha-2': 'DE'
    }, {
        'name': 'district of columbia',
        'alpha-2': 'DC'
    }, {
        'name': 'florida',
        'alpha-2': 'FL'
    }, {
        'name': 'georgia',
        'alpha-2': 'GA'
    }, {
        'name': 'hawaii',
        'alpha-2': 'HI'
    }, {
        'name': 'idaho',
        'alpha-2': 'ID'
    }, {
        'name': 'illinois',
        'alpha-2': 'IL'
    }, {
        'name': 'indiana',
        'alpha-2': 'IN'
    }, {
        'name': 'iowa',
        'alpha-2': 'IA'
    }, {
        'name': 'kansa',
        'alpha-2': 'KS'
    }, {
        'name': 'kentucky',
        'alpha-2': 'KY'
    }, {
        'name': 'lousiana',
        'alpha-2': 'LA'
    }, {
        'name': 'maine',
        'alpha-2': 'ME'
    }, {
        'name': 'maryland',
        'alpha-2': 'MD'
    }, {
        'name': 'massachusetts',
        'alpha-2': 'MA'
    }, {
        'name': 'michigan',
        'alpha-2': 'MI'
    }, {
        'name': 'minnesota',
        'alpha-2': 'MN'
    }, {
        'name': 'mississippi',
        'alpha-2': 'MS'
    }, {
        'name': 'missouri',
        'alpha-2': 'MO'
    }, {
        'name': 'montana',
        'alpha-2': 'MT'
    }, {
        'name': 'nebraska',
        'alpha-2': 'NE'
    }, {
        'name': 'nevada',
        'alpha-2': 'NV'
    }, {
        'name': 'new Hampshire',
        'alpha-2': 'NH'
    }, {
        'name': 'new jersey',
        'alpha-2': 'NJ'
    }, {
        'name': 'new mexico',
        'alpha-2': 'NM'
    }, {
        'name': 'new york',
        'alpha-2': 'NY'
    }, {
        'name': 'north carolina',
        'alpha-2': 'NC'
    }, {
        'name': 'north dakota',
        'alpha-2': 'ND'
    }, {
        'name': 'ohio',
        'alpha-2': 'OH'
    }, {
        'name': 'oklahoma',
        'alpha-2': 'OK'
    }, {
        'name': 'oregon',
        'alpha-2': 'OR'
    }, {
        'name': 'pennsylvania',
        'alpha-2': 'PA'
    }, {
        'name': 'rhode island',
        'alpha-2': 'RI'
    }, {
        'name': 'south carolina',
        'alpha-2': 'SC'
    }, {
        'name': 'south dakota',
        'alpha-2': 'SD'
    }, {
        'name': 'tennessee',
        'alpha-2': 'TN'
    }, {
        'name': 'texas',
        'alpha-2': 'TX'
    }, {
        'name': 'utah',
        'alpha-2': 'UT'
    }, {
        'name': 'vermont',
        'alpha-2': 'VT'
    }, {
        'name': 'virginia',
        'alpha-2': 'VA'
    }, {
        'name': 'washington',
        'alpha-2': 'WA'
    }, {
        'name': 'west virginia',
        'alpha-2': 'WV'
    }, {
        'name': 'wisconsin',
        'alpha-2': 'WI'
    }, {
        'name': 'wyoming',
        'alpha-2': 'WY'
    }];
}

export function arrayContains(value, array) {
    for (let i = 0; i < array.length; i++) {
        if (value === array[i]) {
            return true;
        }
    }
    return false;
}

export function profile() {
    return DashboardModel.get('relationships').profile.profile;
}

/**
 * get profile model data to pass to template
 * @return {object} the profile model
 */
export function profileModel() {
    return DashboardModel.get('relationships').profile;
}

/**
 * get the subscriptions object from the profile model to pass to template
 * @return {object} the subscriptions object of the profile model
 */
export function subscriptions() {
    return DashboardModel.get('relationships').profile.subscriptions;
}

export function userAddresses() {
    return DashboardModel.get('relationships').address.userAddresses;
}

export function userPayments() {
    return DashboardModel.get('relationships').address.userPayments;
}

export function userStores() {
    return DashboardModel.get('relationships').stores.favoriteStores;
}

export function isPaymentIdOrphaned(paymentId) {
    return undefined !== _.find(DashboardModel.get('relationships').address.orphanPayments,
        (orphanPayment) => {
            return orphanPayment.id === paymentId;
        });
}

export function getLength(array) {
    return array.length;
}

export function urlContains(param) {
    let urlParam = false;

    if (window.location.href.indexOf(param) > -1) {
        urlParam = true;
    }
    return urlParam;
}

export function matchingAddrPayments() {
    let AddrIdsArr = [];

    for (let i = 0; i < AddressModel.userPayments.length; i++) {
        const addrId = AddressModel.userPayments[i].creditCardDetail.addressId;
        AddrIdsArr.push(addrId);
    }

    const uniqueAddrIdsArr = AddrIdsArr.filter(function(a) {
        if (!this[a]) {
            this[a] = 1;
            return a;
        }
    }, {});

    return uniqueAddrIdsArr;
}

export function sliceEmailAddr(emailAddr) {
    const slicedEmail = emailAddr.slice(0, emailAddr.indexOf('@'));

    return slicedEmail;
}

/**
 * Convert a unix timestamp into a date string to be used in the templates; ex 'March 1, 2015'
 * @param {string} date - unix timestamp returned from /me/order/history for order date
 * @returns {string} The date as a string
 */
export function convertUnixTime(date) {
    const thisDate = new Date(date * 1000);
    const day = thisDate.getDate();
    const monthNumber = thisDate.getMonth();
    const months = this.months(); // call months helper function to get an array of month names as strings
    const month = months[monthNumber].name;
    const year = thisDate.getFullYear();

    return `${month} ${day}, ${year}`;
}

/**
 * Gets the index of the current site based on siteId value
 * @param  {object} state The current state of the redux store
 * @return {number}       The index of the current site
 */
export function getSiteBySiteId(state) {
    const contextCore = getCoreContext(state);

    for (let site in contextCore.siteConfig.sites) {
        if (contextCore.siteConfig.sites[site].siteId === contextCore.siteId) {
            return site;
        }
    }
}

/**
 * Gets the index of the current country based on a value derived from siteId
 * @param  {object} state The current state of the redux store
 * @return {number}       The index of the current country
 */
export function getCountryIndexBySelectedCountry(state) {
    const contextCore = getCoreContext(state);
    const tempAddressCountry = _.get(AddressModel, 'temp.address.country');
    const selectedCountryElement = document.getElementById('account-address-country-select');
    const countries = contextCore.siteConfig.allCountries;
    const akamaiLocation = contextCore.userLocation.country_code;

    if (selectedCountryElement) {
        return findIndexInCountriesList(countries, contextCore, selectedCountryElement.value);
    } else if (tempAddressCountry) {
        return findIndexInCountriesList(countries, contextCore, tempAddressCountry);
    } else {
        return findIndexInCountriesList(countries, contextCore, akamaiLocation);
    }
}

function findIndexInCountriesList(countries, contextCore, currCountry) {
    const foundIndex = _.findIndex(countries, (country) => country.countryCode === currCountry);

    return foundIndex >= 0 ? foundIndex : 0;
}

/**
 * checks to see if credit card is expired
 * @param  {Int} expirationMonth the credit card expiration month
 * @param  {Int} expirationYear  the credit card expiration year
 * @return {Boolean}             true if credit card is expired, false if not
 */
export function creditCardIsExpired(expirationMonth, expirationYear) {
    const today = new Date();
    const creditCardDay = new Date();
    creditCardDay.setFullYear(expirationYear, expirationMonth, 1);

    if (creditCardDay < today) {
        return true;
    } else {
        return false;
    }
}

function getCoreContext(state) {
    if (typeof state.core !== 'undefined') {
        return state.core;
    } else {
        return state;
    }
}

export function formatEmployeeId(employeeIdNumber, employeeIdLength) {
    const employeeIdDesiredLength = (employeeIdLength < 8) ? 8 : 10;
    return employeeIdNumber.padStart(employeeIdDesiredLength, '0');
}
